<template>
  <v-card class="mx-auto"  min-height="268">
    <v-toolbar flat color="blue-grey" dark>
      <v-toolbar-title>Booking Summary</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-col cols="12" class="mt-0 mb-0">
        <span class="d-block text-subtitle-2 font-weight-black">Check In:</span>
        <span class="text-subtitle-2">{{ formatDate(GetArrival()) }}</span>
      </v-col>
      <v-col cols="12" class="mt-0 mb-0"><span class="d-block text-subtitle-2 font-weight-black">Check Out:</span>
        <span class="text-subtitle-2">{{ formatDate(GetDeparture()) }}</span>
      </v-col>
      <!-- <v-col cols="12" v-for="(room, iroom) in GetBookingInfo()" :key="iroom">
        <v-row no-gutters>
          <v-col cols="6" class="text-subtitle-2 font-weight-black">{{ room.name }}</v-col>
          <v-col cols="6">{{ room.displayTotalPrice }} <v-btn icon color="red" @click="removeRoom(room)">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col> -->
      <v-divider></v-divider>
      <v-col cols="12">
        <v-row no-gutters>
          <v-col cols="6" class="text-subtitle-2 font-weight-black">Room Charges</v-col>
          <v-col cols="1" class="text-subtitle-2 font-weight-black">Qty</v-col>
          <v-col cols="4" class="text-subtitle-2 text-center font-weight-black">Amount</v-col>
          <v-col cols="1"></v-col>
        </v-row>
      </v-col>

      <section style="overflow: auto;max-height: 450px;">
        <template v-for="(roomReserve, iroomReserve) in roomReserves">
        <v-col cols="12" v-if="roomReserve !== null && roomReserve !== undefined" :key="iroomReserve + 'grandSummary'">
          <v-row no-gutters>
            <v-col cols="6" style="line-height: 1 !important">
              <span class="text-subtitle-2 font-weight-black">
                
                {{ roomReserve.ratePlan.hotDealsType === 'PackageDeal' 
                || roomReserve.ratePlan.hotDealsType === 'PayStayDeal' ?
                roomReserve.ratePlan.room.roomName :  roomReserve.room.roomName 
                 }}
                ({{ formatDateShort(roomReserve.startDate) }}) -
                ({{ formatDateShort(roomReserve.endDate) }})
              </span>
              <br />
              {{ roomReserve.ratePlan.rateName }}
              <br />
              {{ roomReserve.ratePlan.hotDealName }}
            </v-col>
            <v-col cols="1" class="d-flex align-center justify-center font-weight-black">
            
               1
            </v-col>
            <v-col cols="4" class="text-center">

              {{ roomReserve.ratePlan.displayTotalPrice }}

            </v-col>
            <v-col cols="1" class="d-flex align-center">
              <v-btn icon color="red" @click="removeRoom(roomReserve)">
                <v-icon>mdi-trash-can</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" class="mb-0 mt-0 pb-0 pt-0" v-for="(service, iservice) in roomReserve.services"
          :key="iservice + '-bookingInfo-col' + iroomReserve + 'parent'">
          <v-row no-gutters>
            <v-col cols="6" class="my-1" style="line-height: 1 !important;">
              {{ service.name }}
            </v-col>
            <v-col cols="1" class="font-weight-black">
              {{ service.quantity }}
            </v-col>
            <v-col cols="4" class="text-center">{{ service.displayPrice }}

            </v-col>
            <v-col cols="1"></v-col>
          </v-row>
        </v-col>
      </template>
      </section>
      
      <!-- <div class="text-center" style="background-color: transparent;">
        See More
      </div> -->


      <v-divider></v-divider>
      <v-col cols="12" class="mt-0 mb-0 pt-0 pb-0">
        <v-row no-gutters>
          <v-col cols="6" class="text-subtitle-1 font-weight-black deep-orange--text  text--laccent-3">Grand Total
          </v-col>
          <v-col cols="6" class="text-subtitle-1 font-weight-black deep-orange--text  text--laccent-3">
            {{ GetGrandBookingSummary().displayGrandTotalAmount }}</v-col>
        </v-row>
      </v-col>
      <v-col cols="12" class="mt-0 mb-0 pt-0 pb-0">
        <v-row no-gutters>
          <v-col cols="6" class="text-subtitle-1 font-weight-black teal--text  text--darken-1">Deposit</v-col>
          <v-col cols="6" class="text-subtitle-1 font-weight-black teal--text  text--darken-1">
            {{ GetGrandBookingSummary().displayDepositAmount }}</v-col>
        </v-row>
      </v-col>
      <v-divider></v-divider>
    </v-card-text>

    <v-card-actions>
      <v-btn depressed href="#paymentDetails" v-if="roomReserves.length !== 0 && GetActiveScreen() !== 'bookingDetail'" color="success" class="mx-auto" @click="onMakeBooking">
        Proceed to payment
      </v-btn>


      <!-- <v-btn depressed color="primary" class="mx-auto" @click="onBooked">
        Test
      </v-btn> -->
    </v-card-actions>

  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import moment from 'moment';

export default {
  data: () => ({
    reveal: false,
    timeoutId: null,
  }),
  methods: {
    formatDate(date) {
      return moment(date).format('dddd Do MMMM YYYY')
    },
    formatDateShort(date) {
      return moment(date).format('DD/MM/YYYY')
    },
    onMakeBooking: function () {
      this.$store.dispatch('setActiveScreen', 'bookingDetail');
    },
    onBooked: function () {
      this.$store.dispatch('setActiveScreen', 'addRoom');
    },
    removeRoom: function (room) {
      console.log(room, 'removeRoom methods');
      this.$store.dispatch('removeRoom', room);
    },
    setTimeoutEvent: function () {

      if (this.GetPropertyInformation() === null) {
        return;
      }

      this.timeoutId = setTimeout(() => {
        // let amounts = [];
        let payload = [];
        // let payload = {
        //   amounts: [],
        //   depositPercentage: this.GetPropertyInformation().bookingPolicy.depositAmount
        // };

        this.roomReserves.forEach((r) => {
          let amounts = r.services.map((item) => {
            return {amount: item.amount, isNightRate: false} 
          })
          // amounts.push(r.ratePlan.totalPrice);
          let dailyRates = r.ratePlan.priceList.map((item, idx) => 
        {
          return {amount: item.price, isNightRate: true}          
        });
          amounts.push(...dailyRates);

          let model = {
            amounts: amounts,
            depositPercentage: r.ratePlan.depositPercentage,
            depositPolicy: r.ratePlan.bookingPolicyType
          }

          payload.push(model);

        })

        this.$store.dispatch('getDepositAndGrandTotalMany', payload).then((data) => {
          this.$store.commit('setGrandBookingSummary', data);
        });
      }, 1000)
    }
  },
  computed: {
    ...mapGetters([
      'GetArrival',
      'GetDeparture',
      'GetGrandBookingSummary',
      'GetActiveScreen',
      'GetPropertyInformation',
      'GetRoomReserves']),
    roomReserves: function () {
      if (this.timeoutId !== null) {
        clearTimeout(this.timeoutId);
        this.setTimeoutEvent();
      } else {
        this.setTimeoutEvent();
      }
      return [...this.GetRoomReserves()];
    }
  }
};
</script>

<style>
.v-card--reveal {
  bottom: 0;
  opacity: 1 !important;
  position: absolute;
  width: 100%;
}
</style>